import React, { useState } from "react";
import { NonEssentialLoadItems } from "../../utills/CommonData";
import { TiPlus } from "react-icons/ti";
// import AppliancesInputFileds from "./AppliancesInputFileds";

const NonEssentials = ({
  appliances,
  handleInputChange,
  handleAddAppliancesField,
  handleRemoveInputField,
}) => {
  return (
    <div className="border rounded h-96 overflow-scroll custom-scrollbar overflow-x-hidden bg-gray-800">
      {NonEssentialLoadItems.map((item) => (
        <div key={item?.id}>
          <div className="flex justify-between text-white items-center py-5 sm:px-10 px-2">
            <div className="flex flex-row justify-center items-center gap-5">
              <img src={item.icon} alt={item.name} className="w-5" />
              <span>{item.name}</span>
            </div>

            <button
              className="bg-error text-white p-1 rounded-full"
              onClick={() => handleAddAppliancesField(item)}
            >
              <TiPlus />
            </button>
          </div>
          {appliances[item.id] &&
            appliances[item.id].map((input, index) => {
              return (
                <div
                  key={input?.id}
                  className="flex flex-row sm:gap-4 gap-1 justify-around py-2 items-center sm:px-10 sm:text-base text-sm"
                >
                  <select
                    className="border w-full text-black sm:p-2 p-1 rounded"
                    value={input.wattage}
                    name="wattage"
                    onChange={(e) =>
                      handleInputChange(
                        item.id,
                        index,
                        "wattage",
                        e.target.value
                      )
                    }
                  >
                    <option value=""> Select option</option>
                    <option value="40W">40W</option>
                    <option value="60W">60W</option>
                    <option value="100W">100W</option>
                  </select>
                  <input
                    name="quantity"
                    value={input.quantity}
                    placeholder="Quantity"
                    type="number"
                    className="bg-white rounded text-black sm:w-28 w-16 sm:p-2 p-1"
                    onChange={(e) =>
                      handleInputChange(
                        item.id,
                        index,
                        "quantity",
                        e.target.value
                      )
                    }
                  />
                  <input
                    name="hours"
                    value={input.hours || ""}
                    type="number"
                    placeholder="Eg:1hour"
                    className="bg-white rounded text-black sm:w-28 w-16 sm:p-2 p-1"
                    onChange={(e) =>
                      handleInputChange(item.id, index, "hours", e.target.value)
                    }
                  />
                  <button
                    className="text-white text-xs"
                    onClick={() => handleRemoveInputField(item.id, index)}
                  >
                    ✖
                  </button>
                </div>
              );
            })}{" "}
        </div>
      ))}
    </div>
  );
};

export default NonEssentials;
